/** @format */

const MessageHistoryActionTypes = {
  FETCH_MESSAGE_HISTORY_START: 'FETCH_MESSAGE_HISTORY_START',
  FETCH_MESSAGE_HISTORY_SUCCESS: 'FETCH_MESSAGE_HISTORY_SUCCESS',
  FETCH_MESSAGE_HISTORY_FAILURE: 'FETCH_MESSAGE_HISTORY_FAILURE',
};

export default MessageHistoryActionTypes;
